import palette from '@lib/core/src/theme/palette';
import { List, Typography, styled, ListItemButton, Stack } from '@mui/material';

import { BREAKPOINT_SMALL } from '@/components/Header/HeaderStyles';

import { USER_DETAILS_HEIGHT } from './UserDetails';

export const SIDEBAR_WIDTH = '200px';

export const SidebarList = styled(List)({
  padding: '0',
  lineHeight: 'normal'
});

export const SidebarListItemButton = styled(ListItemButton, {
  shouldForwardProp: prop => prop !== 'active'
})<{
  active?: boolean;
}>(({ active }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  padding: '8px',
  borderRadius: '8px',
  cursor: 'pointer',
  ...(active
    ? {
        backgroundColor: 'rgba(47, 47, 47, 0.05)',
        color: palette.black
      }
    : {
        color: palette.grey[400],
        '&:hover': {
          backgroundColor: 'rgba(47, 47, 47, 0.05)'
        }
      })
}));

export const SidebarListItemIcon = styled(Stack)({
  color: 'inherit'
});

export const SidebarListItemText = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  [theme.breakpoints.down(BREAKPOINT_SMALL)]: {
    fontSize: '15px'
  }
}));

export const InviteJourneyButton = styled(Stack)({
  margin: '16px 0',
  flexDirection: 'row',
  alignItems: 'center',
  border: `1px solid ${palette.blue[1300]}`,
  gap: '8px',
  padding: '8px',
  borderRadius: '6px',
  color: palette.black,
  backgroundColor: palette.white,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: palette.grey[100],
    color: palette.black
  }
});

export const UserDetailsWrapper = styled(Stack)({
  justifyContent: 'flex-end',
  height: USER_DETAILS_HEIGHT
});

export const SidebarScrollContent = styled(Stack)({
  height: `calc(100% - ${USER_DETAILS_HEIGHT})`,
  overflowY: 'auto',
  padding: '0 8px'
});
